import { formatMoney } from "@/utils/generalUtilities";

interface SavingsCardProps {
  title: string;
  amount: number;
  className?: string;
}

const SavingsCard = ({ title, amount, className = "" }: SavingsCardProps) => (
  <div
    className={`flex flex-col justify-between border rounded-xl bg-white p-[16px] lg:py-8 w-full lg:p-7 ${className}`}
  >
    <p>{title}</p>
    <p className="text-[24px] lg:text-[30px] font-semibold mt-3">
      ${formatMoney(Math.trunc(amount))}
    </p>
  </div>
);

export default SavingsCard;
